// Karma Experience — Mock Data
// All content here so backend swap is easy later

export const brand = {
  name: 'Karma Experience',
  tagline: 'A Collection of Extraordinary Escapes',
  activationUrl: '/activate',
};

export const hero = {
  eyebrow: 'Karma Experience',
  headline: 'Start Your Karma Experience',
  sub: 'A collection of extraordinary escapes across Europe and Asia, carefully selected to create unforgettable memories.',
  primaryCta: 'Explore Your Experience',
  secondaryCta: 'Activate Your Voucher',
  image: '/images/l8i9ja8d_KK_gallery-16__1_.jpg',
};

export const welcome = {
  eyebrow: 'Welcome',
  headline: 'A Journey Curated With Care',
  body: [
    'Karma Experience has been thoughtfully created to invite you to a collection of extraordinary destinations, exceptional hospitality and unforgettable stays.',
    'Whether you long for ancient wonders, idyllic islands or peaceful escapes, we look forward to welcoming you on your next adventure — with the calm reassurance of a trusted international luxury travel company at your side.',
  ],
  image: '/images/photo-1567787783547-eb2b6722667d.jpg',
};

export const howItWorks = {
  eyebrow: 'Your Journey',
  headline: 'From inspiration to unforgettable memories',
  steps: [
    { n: '1', title: 'Activate your voucher', desc: 'A simple, secure activation — the first gentle step of your journey.' },
    { n: '2', title: 'Choose your destination', desc: 'Explore our curated collection across Europe and Asia.' },
    { n: '3', title: 'Speak with our Experience Team', desc: 'A dedicated travel expert helps shape the perfect trip.' },
    { n: '4', title: 'Confirm your travel', desc: 'Flexible planning around dates and preferences that suit you.' },
    { n: '5', title: 'Create unforgettable memories', desc: 'Arrive, unwind and immerse yourself in the experience.' },
  ],
};

export const whatsIncluded = {
  eyebrow: "What's Included",
  headline: 'Every detail is taken care of',
  sub: 'So you can simply relax and enjoy the journey.',
  items: [
    { icon: 'Sparkles', title: 'Luxury Accommodation', desc: 'Handpicked properties in breathtaking locations.' },
    { icon: 'Globe2', title: 'Curated Destinations', desc: 'A collection across Europe and Asia.' },
    { icon: 'Headset', title: 'Dedicated Travel Support', desc: 'A personal Experience Team, always on hand.' },
    { icon: 'CalendarHeart', title: 'Flexible Travel Planning', desc: 'Dates and stays shaped around you.' },
    { icon: 'Gem', title: 'Exclusive Experiences', desc: 'Moments beyond the ordinary itinerary.' },
    { icon: 'BadgeCheck', title: 'Simple Activation', desc: 'A calm, effortless first step.' },
  ],
};

// Interactive world map — country coordinates on a stylised map (percent based)
// x: 0-100 horizontal, y: 0-100 vertical. Only countries where Karma resorts operate.
export const mapCountries = [
  { id: 'england',   name: 'England',   x: 46,   y: 30 },
  { id: 'bavaria',   name: 'Germany',   x: 50,   y: 34 },
  { id: 'borgo',     name: 'Italy',     x: 51,   y: 42 },
  { id: 'egypt',     name: 'Egypt',     x: 56,   y: 52 },
  { id: 'vietnam',   name: 'Vietnam',   x: 77,   y: 55 },
  { id: 'cambodia',  name: 'Cambodia',  x: 75.5, y: 57 },
  { id: 'thailand',  name: 'Thailand',  x: 74,   y: 58 },
  { id: 'bali',      name: 'Indonesia', x: 80,   y: 70 },
];

// Destinations — one chapter each
// Real resort data sourced from karmaexperience.co.uk (Nov 2025 crawl).
// Descriptions rewritten in our editorial voice.
export const destinations = [
  {
    id: 'england',
    chapter: '01',
    country: 'England',
    pull: 'Tudor charm. English gardens. A gentle countryside escape.',
    tagline: 'HISTORIC CHARM.\nENGLISH GARDENS.\nA QUIET ESCAPE.',
    intro: 'From honey-stone manor houses to the softly rolling Vale of Evesham, England reveals a timeless calm. A place to slow down, breathe deeply and rediscover the pleasure of quiet luxury.',
    location: 'Northern Europe',
    locationDesc: 'Nestled in Warwickshire\u2019s Vale of Evesham, Karma Salford Hall is a 700-year-old Tudor retreat, minutes from the Cotswolds and Stratford-upon-Avon.',
    heroImage: '/images/photo-1568144510602-c4082cb85d43.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Salford Hall', place: 'The Vale of Evesham',
        desc: 'A 700-year-old Tudor manor of oak-panelled rooms, mullioned windows and English gardens \u2014 a quietly historic countryside retreat in the heart of Warwickshire.',
        image: '/images/so0s84ei_Exterior.jpg',
        nights: '3 / 4 Nights',
        features: [
          { icon: 'Landmark', label: 'Tudor Manor' },
          { icon: 'Trees', label: 'English Gardens' },
          { icon: 'Flame', label: 'Log Fires' },
          { icon: 'Wine', label: 'Fine Dining' },
        ],
        perfectFor: 'Couples, history lovers, quiet escapes',
        gallery: [
          '/images/so0s84ei_Exterior.jpg',
          '/images/mc54dlbv_ksh_1.jpg',
          '/images/os902ack_Karma_Salford_Hall_dining.jpg',
          '/images/wta3jb5w_a19942a8-gallery-superior-double-room-02.jpg',
          '/images/1kil86bn_485f795a-kss_gallery_12022021_17.jpg',
          '/images/z9dmfifu_ksh_6.jpg',
        ],
      },
    ],
  },
  {
    id: 'bavaria',
    chapter: '02',
    country: 'Bavaria',
    pull: 'Alpine air. Storybook villages. Lake-still quiet.',
    tagline: 'ALPINE AIR.\nSTORYBOOK VILLAGES.\nLAKE-STILL QUIET.',
    intro: 'Southern Germany invites you into a landscape of mirror-still lakes, fairytale villages and mountain silence. Days move gently here, and every window frames a postcard.',
    location: 'Central Europe',
    locationDesc: 'Karma Bavaria sits above Lake Schliersee in the Bavarian Alps \u2014 a picture-perfect alpine setting of fresh mountain air and easy calm.',
    heroImage: '/images/photo-1611312456567-bd76240dcaf4.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Bavaria', place: 'Schliersee',
        desc: 'A refined alpine hideaway above Lake Schliersee \u2014 restorative walks through the mountains, traditional Bavarian warmth and the timeless comfort of a fairytale setting.',
        image: '/images/4o8f6ezw_karma-bavaria-gallery-141022-16.jpg',
        nights: '4 / 7 Nights',
        features: [
          { icon: 'Mountain', label: 'Alpine Views' },
          { icon: 'Waves', label: 'Lakeside' },
          { icon: 'TreePine', label: 'Forest Trails' },
          { icon: 'Flame', label: 'Cosy Interiors' },
        ],
        perfectFor: 'Nature lovers, couples, quiet retreats',
        gallery: [
          '/images/4o8f6ezw_karma-bavaria-gallery-141022-16.jpg',
          '/images/bk930fpp_Bavaria-pool.jpg',
          '/images/qwy3m84j_kbv_restaurant_1-1.jpg',
          '/images/te5enxb0_fdccadcc-deluxe_room_01.jpg',
          '/images/tf3cevsh_231d6c88-gym-karma-bavaria.jpg',
          '/images/2jgfodr0_gallery_collection_1.jpg',
          '/images/qtygjg99_gallery_games_3.jpg',
        ],
      },
    ],
  },
  {
    id: 'borgo',
    chapter: '03',
    country: 'Italy',
    pull: 'Rolling hills. Renaissance stone. Long, sunlit days.',
    tagline: 'ROLLING HILLS.\nRENAISSANCE STONE.\nSUNLIT DAYS.',
    intro: 'A gentle chapter set within the honeyed light of Tuscany \u2014 the birthplace of the Renaissance. Cypress-lined lanes, vineyards and long lunches beneath ancient olive trees.',
    location: 'Southern Europe',
    locationDesc: 'Karma Borgo Di Colleoli is a restored medieval estate deep in the Tuscan countryside, once home to aristocracy and reborn into contemporary Italian ease.',
    heroImage: '/images/photo-1624356417152-a1069f183130.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Borgo Di Colleoli', place: 'Tuscany',
        desc: 'A hilltop village of restored farmhouses set within its own vineyard estate \u2014 stone terraces, private pools and the unhurried life of the Tuscan countryside.',
        image: '/images/banner-1762777252-kdbc_gallery_new_1.jpg',
        nights: '4 Nights',
        features: [
          { icon: 'Grape', label: 'Vineyard Estate' },
          { icon: 'Wine', label: 'Regional Cuisine' },
          { icon: 'Sun', label: 'Hilltop Views' },
          { icon: 'Palette', label: 'Renaissance Charm' },
        ],
        perfectFor: 'Couples, food & wine lovers, culture',
        gallery: [
          '/images/banner-1762777252-kdbc_gallery_new_1.jpg',
          '/images/2gnl9i0m_Gallery2.jpg',
          '/images/ajh54rtb_KBDC-GALLERY-1.jpg',
          '/images/l1jygn6s_kdbc_gallery_new_3.jpg',
          '/images/w8ihdw2z_kdbc_wine_bar_1-1__1_.jpg',
          '/images/1oke4jt8_kdbc_wine_bar_2-1.jpg',
        ],
      },
    ],
  },
  {
    id: 'egypt',
    chapter: '04',
    country: 'Egypt',
    pull: 'Ancient wonders. Timeless Nile. Endless horizon.',
    tagline: 'ANCIENT WONDERS.\nTIMELESS NILE.\nSLOW WATER JOURNEYS.',
    intro: 'Step into a land where every stone tells a story. Aboard Karma\u2019s first river cruise, Egypt reveals itself slowly \u2014 temple by temple, sunset by sunset \u2014 as the Nile carries you gently between them.',
    location: 'North Africa \u00b7 Nile Cruise',
    locationDesc: 'Karma Karnak begins in Luxor and glides along the Nile past ancient wonders \u2014 a boutique river cruise, not a static resort.',
    heroImage: '/images/photo-1600520611035-84157ad4084d.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Karnak', place: 'Nile River Cruise \u00b7 from Luxor',
        desc: 'Karma Group\u2019s first river cruise \u2014 a boutique journey along the Nile from Luxor, weaving together temples, timeless landscapes and quietly unfolding days aboard.',
        image: '/images/banner-1762432145-banner-1745396865-Karnak_Fushi-01.webp',
        nights: '4 / 7 Nights',
        features: [
          { icon: 'Ship', label: 'River Cruise' },
          { icon: 'Landmark', label: 'Ancient Temples' },
          { icon: 'Sun', label: 'Nile Sunsets' },
          { icon: 'Coffee', label: 'All-inclusive Dining' },
        ],
        perfectFor: 'Culture lovers, couples, history seekers',
        gallery: [
          '/images/banner-1762432145-banner-1745396865-Karnak_Fushi-01.webp',
          '/images/h968zvs9_Pool.png',
          '/images/2nw5e120_DJI_20221124_093545_897.webp',
          '/images/90glrezr_134A5998.webp',
          '/images/opkc2cio_photo_2022-02-04_16-14-07.jpg',
          '/images/c42plffi_photo_2022-02-04_16-13-58.jpg',
        ],
      },
    ],
  },
  {
    id: 'vietnam',
    chapter: '05',
    country: 'Vietnam',
    pull: 'Every journey here tells a story. Which one will be yours?',
    tagline: 'TIMELESS TRADITIONS.\nEMERALD WATERS.\nWARM HOSPITALITY.',
    intro: 'From the lantern-lit streets of Hoi An to the stunning coastline and tropical islands, Vietnam is a land of captivating contrasts. Rich in culture, blessed with natural beauty, it is the perfect place to slow down, explore and reconnect.',
    location: 'Southeast Asia',
    locationDesc: 'Karma\u2019s Vietnamese properties sit along the peaceful outskirts and riversides of Hoi An \u2014 a UNESCO World Heritage town of lanterns, silk and warm welcomes.',
    heroImage: '/images/photo-1563354860-799d15199ac3.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Song Hoai', place: 'Hoi An',
        desc: 'Set on the outskirts of UNESCO-listed Hoi An, Karma Song Hoai blends stylish rooms with vibrant gardens \u2014 a stroll from the lantern-lit lanes of the ancient town.',
        image: '/images/0ytsh81x_gallery-1762517547-banner-1.jpg',
        nights: '7 Nights',
        features: [
          { icon: 'Landmark', label: 'Ancient Town' },
          { icon: 'Sparkles', label: 'Stylish Rooms' },
          { icon: 'Trees', label: 'Lush Gardens' },
          { icon: 'Feather', label: 'Peaceful Retreat' },
        ],
        perfectFor: 'Culture lovers, couples, relaxation',
        gallery: [
          '/images/0ytsh81x_gallery-1762517547-banner-1.jpg',
          '/images/7ajyvxxy_gallery-1762517547-banner-2.jpg',
          '/images/l2hjmctd_gallery-1762517547-karma-song-hoai-facilities-gallery-section-26052022-05.jpg',
          '/images/r6lge25z_gallery-1762517547-karma-song-hoai-facilities-gallery-section-26052022-04.jpg',
          '/images/d3np1a51_gallery-1762517547-karma-song-hoai-banner-26052022-03.jpg',
          '/images/gygupizr_gallery-1762517547-karma-song-hoai-gallery-26052022-02.jpg',
        ],
      },
      {
        n: '2', name: 'Karma Duy\u00ean', place: 'Hoi An',
        desc: 'A tranquil riverside sanctuary surrounded by rice fields, coconut groves and gentle waterways \u2014 moments from the lanterns of old Hoi An, worlds away in feel.',
        image: '/images/37luj9ui_gallery-1785480224-2.png',
        nights: '7 Nights',
        features: [
          { icon: 'Waves', label: 'Riverside' },
          { icon: 'TreePine', label: 'Rice Fields' },
          { icon: 'Flower2', label: 'Serene Setting' },
          { icon: 'Users', label: 'Family Friendly' },
        ],
        perfectFor: 'Couples, families, nature lovers',
        gallery: [
          '/images/37luj9ui_gallery-1785480224-2.png',
          '/images/ywwzp6wv_gallery-1785480224-1.png',
          '/images/7jobxlmz_gallery-1785480224-3.png',
          '/images/4w032b6q_gallery-1785480224-5.jpg',
          '/images/p8nj8w16_gallery-1785480224-4.png',
        ],
      },
    ],
  },
  {
    id: 'cambodia',
    chapter: '06',
    country: 'Cambodia',
    pull: 'Ancient temples. River-quiet days. Warm Khmer smiles.',
    tagline: 'ANCIENT TEMPLES.\nRIVER-QUIET DAYS.\nWARM KHMER SMILES.',
    intro: 'Moments from the majesty of Angkor Wat, Cambodia unfolds slowly \u2014 golden temples at dawn, tuk-tuks weaving through lantern-lit lanes, and evenings by the river as the day softens into gold.',
    location: 'Southeast Asia \u00b7 Siem Reap',
    locationDesc: 'Karma Bayon sits along the peaceful riverside of Siem Reap \u2014 just five kilometres from Angkor Wat, wrapped in tropical gardens and the gentle warmth of Khmer hospitality.',
    heroImage: '/images/photo-1566706546199-a93ba33ce9f7.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Bayon Siem Reap', place: 'Siem Reap',
        desc: 'A cultural riverside retreat just minutes from the temples of Angkor \u2014 modern comfort woven with Khmer craftsmanship, two tranquil swimming pools and unhurried evenings on the riverside terrace.',
        image: '/images/fi163h98_karma-bayon-gallery-section-image-03.jpg',
        nights: '7 Nights',
        features: [
          { icon: 'Landmark', label: 'Ancient Temples' },
          { icon: 'Waves', label: 'Two Pools' },
          { icon: 'UtensilsCrossed', label: 'Riverside Dining' },
          { icon: 'Flower2', label: 'Karma Spa' },
        ],
        perfectFor: 'Culture lovers, couples, families',
        gallery: [
          '/images/fi163h98_karma-bayon-gallery-section-image-03.jpg',
          '/images/l2bddb2j_karma-bayon-gallery-section-image-02.jpg',
          '/images/wom9rnmt_karma-bayon-gallery-section-image-04.jpg',
          '/images/4t9bcxgj_karma-bayon-gallery-section-image-05.jpg',
          '/images/9dpean1s_karma-bayon-gallery-section-image-06.jpg',
        ],
      },
    ],
  },
  {
    id: 'thailand',
    chapter: '07',
    country: 'Thailand',
    pull: 'Island calm. Palm-fringed beaches. Warm smiles.',
    tagline: 'ISLAND CALM.\nPALM-FRINGED BEACHES.\nWARM SMILES.',
    intro: 'From the white-sand shores of Koh Samui to the palm-lined waterways of Phuket, Thailand blends adventure and ease like nowhere else. A gentle rhythm, always — with warm smiles at every turn.',
    location: 'Southeast Asia \u00b7 Koh Samui & Phuket',
    locationDesc: 'Our Thai properties are set across two of the country\u2019s most beloved coastlines \u2014 the quiet northern shores of Koh Samui and the marina-side calm of Phuket \u2014 palm-fringed, unhurried, and quintessentially Thai.',
    heroImage: '/images/photo-1528181304800-259b08848526.jpg',
    resorts: [
      {
        n: '1', name: 'Karma Panalee', place: 'Bang Po Beach, Koh Samui',
        desc: 'A serene island resort tucked along the peaceful sands of Bang Po Beach \u2014 tranquil pools, lush tropical grounds and the unhurried pace of Samui life.',
        image: '/images/xean5xbx_gallery_2-min.jpg',
        nights: '7 Nights',
        features: [
          { icon: 'Sun', label: 'Beachfront' },
          { icon: 'Trees', label: 'Tropical Grounds' },
          { icon: 'Waves', label: 'Quiet Bay' },
          { icon: 'Flower2', label: 'Spa & Wellness' },
        ],
        perfectFor: 'Couples, families, wellness',
        gallery: [
          '/images/xean5xbx_gallery_2-min.jpg',
          '/images/h8t6iv77_gallery-1762512844-gallery-1743573474-Gallery-Panalee-08.webp',
          '/images/pdxnbwg4_gallery_5-min.jpg',
          '/images/cwbmkjso_Karma_Panalee_cuisine_03-min.jpg',
          '/images/3b3vxwf6_gallery_v_1-min.jpg',
        ],
      },
      {
        n: '2', name: 'Karma Sawet', place: 'Mae Nam, Koh Samui',
        desc: 'A tranquil island escape in coastal Mae Nam \u2014 framed by palms, quiet stretches of shore and the easy hospitality of Samui\u2019s north coast.',
        image: '/images/br7sc1eh_sawet_gallery_1.jpg',
        nights: '7 Nights',
        features: [
          { icon: 'Sun', label: 'Coastal Setting' },
          { icon: 'UtensilsCrossed', label: 'Local Cuisine' },
          { icon: 'Feather', label: 'Peaceful Retreat' },
          { icon: 'Waves', label: 'Island Escape' },
        ],
        perfectFor: 'Couples, families, sun-seekers',
        gallery: [
          '/images/br7sc1eh_sawet_gallery_1.jpg',
          '/images/a53v8udj_gallery-17841975420-IMG_8711.jpg',
          '/images/4lzi75o2_one_bedroom_sawet_1.jpg',
          '/images/qafvnv7b_sawet_gallery_2.jpg',
          '/images/g247lk46_sawet_gallery_16.jpg',
        ],
      },
      {
        n: '3', name: 'Karma Royal Boat Lagoon', place: 'Phuket',
        desc: 'A stylish marina-side retreat within Phuket\u2019s exclusive Boat Lagoon \u2014 tropical courtyards, waterside dining and easy access to the island\u2019s beaches and old town.',
        image: '/images/92sdg2rd_nh_boat_lagoon_resort_gallery_pool_2.jpg',
        nights: '7 Nights',
        features: [
          { icon: 'Anchor', label: 'Marina Setting' },
          { icon: 'Waves', label: 'Pool & Lagoon' },
          { icon: 'UtensilsCrossed', label: 'Waterside Dining' },
          { icon: 'Dumbbell', label: 'Wellness Facilities' },
        ],
        perfectFor: 'Couples, families, explorers',
        gallery: [
          '/images/92sdg2rd_nh_boat_lagoon_resort_gallery_pool_2.jpg',
          '/images/hv30fu82_krbl_premier_lagoon_deluxe_2-2.jpg',
          '/images/1k8zhk6t_nh_boat_lagoon_phuket_resort_8_restaurant_harbour_1920x1037.jpg',
          '/images/3her9vr8_nh_boat_lagoon_resort_gallery_bar.jpg',
          '/images/10zwcj9i_nh_boat_lagoon_resort_gallery_gym_2.jpg',
          '/images/00vr70t7_boat-lagoon-gallery-entrance.jpg',
        ],
      },
    ],
  },
  {
    id: 'bali',
    chapter: '08',
    country: 'Indonesia',
    pull: 'Sacred spirit. Emerald jungle. Endless ocean.',
    tagline: 'SACRED SPIRIT.\nEMERALD JUNGLE.\nENDLESS OCEAN.',
    intro: 'Bali moves to a slower rhythm \u2014 one of temple bells, rice terraces and warm ocean breezes. Every day here feels a little like a gift.',
    location: 'Southeast Asia \u00b7 Bali',
    locationDesc: 'The jewel of Indonesia \u2014 Karma\u2019s Bali flagship sits high on the Ungasan cliffs of the Bukit Peninsula, with sweeping 360\u00b0 views of the Indian Ocean and a private beach cove far below.',
    heroImage: '/images/photo-1537996194471-e657df975ab4.jpg',
    resorts: [
      {
        n: '1', name: 'Mentari Residences at Karma Kandara', place: 'Ungasan, Bali',
        desc: 'Karma\u2019s flagship Bali resort, perched on the Ungasan cliffs with sweeping 360\u00b0 views of the Indian Ocean, a private beach cove and villas to remember.',
        image: '/images/y414y3h4_IMG_3194.webp',
        nights: '7 Nights',
        features: [
          { icon: 'Mountain', label: 'Clifftop Location' },
          { icon: 'Home', label: 'Private Villas' },
          { icon: 'Waves', label: 'Beach Cove' },
          { icon: 'UtensilsCrossed', label: 'Fine Dining' },
        ],
        perfectFor: 'Couples, luxury seekers',
        gallery: [
          '/images/y414y3h4_IMG_3194.webp',
          '/images/ys1qsmvt_mentari-main-2.jpg',
          '/images/6llq280r_kk-gallery-20220926-17.jpg',
          '/images/v2rsj7nt_kk-gallery-20220926-16.jpg',
          '/images/ic7o3fd5_mentari-kk-studio-apartment-1.jpg',
        ],
      },
    ],
  },
];

export const editorial = [
  { icon: 'BedDouble',  title: 'Accommodation', body: 'Exceptional properties in breathtaking locations, carefully chosen for atmosphere, comfort and quiet luxury.', image: '/images/fjv05kle_krbl_premier_lagoon_deluxe_2-2.jpg' },
  { icon: 'Flower2',    title: 'Wellness',      body: 'Relax, rejuvenate and reconnect in surroundings designed to nourish both body and mind.', image: '/images/lpe9oap8_karma_wellness_3.jpg' },
  { icon: 'UtensilsCrossed', title: 'Cuisine',  body: 'Savour the flavours of each destination — locally inspired, beautifully prepared, quietly memorable.', image: '/images/slqstsrl_0cf22d6e-kss_gallery_12022021_06.jpg' },
  { icon: 'Compass',    title: 'Experiences',   body: 'Curated activities and unforgettable moments — nature, culture and adventure at a comfortable pace.', image: '/images/photo-1762972398785-e872d4f79fbf.jpg' },
  { icon: 'Headset',    title: 'Dedicated Service', body: 'From reservations to travel documents, a personal Experience Team looks after every detail of your journey.', image: '/images/x55wv2ig_DSC_6423__002_.webp' },
  { icon: 'ShieldCheck',title: 'Money Back Guarantee', body: 'Complete peace of mind. If we cannot offer a destination that fits your dates, your voucher value is protected.', image: '/images/pexels-photo-33175650.jpg' },
];

export const trustPoints = {
  eyebrow: 'The Karma Difference',
  headline: 'Why thousands choose Karma.',
  sub: 'Trust is quietly earned. Here is how we build it, one detail at a time.',
  items: [
    { icon: 'Sparkles',   text: 'Hand-picked resorts in exceptional destinations.' },
    { icon: 'Headset',    text: 'A dedicated Experience Team to guide you.' },
    { icon: 'ShieldCheck',text: 'Secure online activation.' },
    { icon: 'Gem',        text: 'Luxury hospitality with personal service.' },
    { icon: 'Compass',    text: 'A carefully curated collection of unforgettable escapes.' },
  ],
};

export const faqSections = [
  {
    title: 'Before You Activate',
    items: [
      { q: 'What is the Karma Experience?', a: 'The Karma Experience is your invitation to discover a hand-picked collection of exceptional resorts across Europe and Asia. Once your voucher has been activated, our Experience Team will help you plan your stay and guide you through the available destinations and travel options.' },
      { q: 'Why do I need to activate my voucher?', a: 'Activating your voucher confirms your participation in the Karma Experience programme and allows our Experience Team to begin arranging your travel options.' },
      { q: 'Is my payment secure?', a: 'Yes. Your activation is processed using a secure online payment system. Once completed, you\u2019ll receive confirmation and our Experience Team will contact you to begin planning your experience.' },
      { q: 'What happens after I activate?', a: 'After your activation has been completed, you\u2019ll receive confirmation, our Experience Team will contact you, you\u2019ll discuss your preferred destinations and travel dates, and we\u2019ll guide you through the available options and help you plan your experience.' },
    ],
  },
  {
    title: 'Choosing Your Holiday',
    items: [
      { q: 'Which destinations can I choose from?', a: 'Your Karma Experience includes access to a selection of carefully chosen destinations across Europe and Asia. Available destinations and participating resorts are shown throughout this website.' },
      { q: 'Can I choose my preferred destination?', a: 'Yes. We invite you to share your three preferred destinations with our Experience Team, who will walk you through the available travel options — subject to availability and the terms of your voucher.' },
      { q: 'How many nights are included?', a: 'The number of nights included ranges from 4 to 7, depending on the resort you choose. Your Experience Team will confirm the details that apply to your voucher.' },
      { q: 'How many people can travel?', a: 'Your voucher is valid for couples travelling with or without children. Please speak with our Experience Team about accommodation options that best suit your party.' },
      { q: 'Can I request specific travel dates?', a: 'Yes. We\u2019ll do our best to accommodate your preferred travel dates, subject to resort availability and the terms of your voucher.' },
    ],
  },
  {
    title: 'During Your Experience',
    items: [
      { q: 'Are flights included?', a: 'Flights are not included with this offer. Our Experience Team will happily walk you through everything that is included as part of your Karma Experience.' },
      { q: 'Can I extend my stay?', a: 'In many cases, additional nights or upgraded accommodation may be available. Your Experience Team will be happy to discuss the available options.' },
      { q: 'Are upgrades available?', a: 'Depending on availability, room upgrades or additional travel options may be offered. Your Experience Team can provide details during the booking process.' },
    ],
  },
  {
    title: 'Flexibility',
    items: [
      { q: 'Can I change my travel dates?', a: 'If your plans change, please speak with our Experience Team as soon as possible. Any available options will depend on your voucher terms and the resort\u2019s booking conditions.' },
      { q: 'Can someone else use my voucher?', a: 'Your voucher is non-transferable, not for resale, and cannot be exchanged for cash. If you have any questions about transfers or changes, our Experience Team is here to help.' },
      { q: 'How long is my voucher valid?', a: 'Your voucher is valid for 12 months from the date of purchase. If you\u2019re ever unsure, simply contact us and we\u2019ll be happy to help.' },
    ],
  },
  {
    title: 'Peace of Mind',
    items: [
      { q: 'Is there a money-back guarantee?', a: 'Yes. We offer a 14-Day Money Back Guarantee following activation, giving you added confidence and peace of mind.' },
      { q: 'Are there any hidden charges?', a: 'We believe in being transparent. Before you confirm your travel arrangements, our Experience Team will explain exactly what is included within your offer and any optional extras that may be available.' },
      { q: 'Who can I contact if I have questions?', a: 'Our dedicated Experience Team is here to help every step of the way. Whether you have questions before or after activation, we\u2019re only a phone call or email away.' },
    ],
  },
];

export const faq = [];

export const importantInfo = [
  { title: 'Reservations',   body: 'All stays are subject to availability at the time of booking. Early activation allows us the best chance of your preferred dates.' },
  { title: 'Travel Documents', body: 'Guests are responsible for valid passports, visas and travel insurance appropriate to their journey.' },
  { title: 'Health & Safety', body: 'Please refer to local travel advice for your chosen destination prior to travelling.' },
  { title: 'Terms & Conditions', body: 'Full terms and conditions are available on request from our Experience Team.' },
];

export const finalCta = {
  headline: 'Your next unforgettable journey begins here.',
  sub: 'Activate your voucher today and let us take care of every detail from this point forward.',
  cta: 'Activate My Karma Experience',
  image: '/images/photo-1575388104683-e076ee9ccaa0.jpg',
};
